<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(v-on="on" color="primary" text) {{ button }}
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ title }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        slot(:close="closeDialog", :opened="dialog")
</template>

<script>
  export default {
    name: "BaseDetailDialog",
    props:{
      title: {
        type: String,
        default: 'Titulo'
      },
      button: {
        type: String,
        default: 'Detalle'
      },
    },
    data:() => ({
      dialog: false,
    }),
    methods:{
      closeDialog(){
        this.dialog = false;
      },
    }
  }
</script>

<style lang="sass">
</style>